import { object, string, AnyObject, StringSchema } from 'yup';

/**
 * Helper to build object schema with conditional required fields,
 * avoiding cyclic dependencies by using object-level test.
 */
export const buildConditionalSchema = (
  fields: Record<
    string,
    {
      label: string;
      message: string;
      extra?: (schema: StringSchema<string, AnyObject>) => StringSchema<string, AnyObject>;
    }
  >
) => {
  const fieldKeys = Object.keys(fields);

  const shape = fieldKeys.reduce((acc, fieldName) => {
    const { label, extra } = fields[fieldName];

    let schema = string().label(label);

    if (extra) {
      schema = extra(schema as StringSchema<string, AnyObject>);
    }

    acc[fieldName] = schema as StringSchema<string, AnyObject>;
    return acc;
  }, {} as Record<string, StringSchema<string, AnyObject>>);

  return object(shape).test(
    'at-least-one-field-filled',
    'Please fill at least one field in this row',
    (value) => {
      if (!value) return true;

      const isAnyFieldFilled = fieldKeys.some(key => {
        const fieldValue = value[key];
        return fieldValue !== undefined && fieldValue !== null && String(fieldValue).trim() !== '';
      });

      if (!isAnyFieldFilled) return true;

      const isAllFieldsFilled = fieldKeys.every(key => {
        const fieldValue = value[key];
        return fieldValue !== undefined && fieldValue !== null && String(fieldValue).trim() !== '';
      });

      return isAllFieldsFilled;
    }
  );
}